<template>
  <div>
    <el-upload
      :class="[showUpload ? 'hidden-Btn' : '']"
      ref="upload"
      action="#"
      list-type="picture-card"
      :http-request="uploadSubmit"
      :on-change="uploadChange"
      :file-list="fileList"
      :limit="limit"
    >
      <i slot="default" class="el-icon-plus"></i>
      <div slot="file" slot-scope="{ file }">
        <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />

        <span class="el-upload-list__item-actions">
          <span class="el-upload-list__item-preview" @click="uploadPreview(file)">
            <i class="el-icon-zoom-in"></i>
          </span>

          <span
            class="el-upload-list__item-delete"
            @click="uploadRemove(file)"
            v-show="!uploadShow"
          >
            <i class="el-icon-delete"></i>
          </span>
        </span>
      </div>
    </el-upload>

    <el-dialog
      title="图片预览"
      :visible.sync="dialogVisible"
      :append-to-body="true"
      class="uploadDialog"
    >
      <img style="max-width: 500px; max-height: 500px" :src="dialogImageUrl" />
    </el-dialog>
  </div>
</template>

<script>
import { getToken } from "@/utils/auth"

import axios from "axios"
export default {
  name: "UploadFile",
  props: {
    imageValue: {
      type: [String, Array],
      default: () => {}
    },
    limit: {
      type: Number,
      default: 1
    },
    uploadShow: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      dialogVisible: false,
      dialogImageUrl: "",
      fileList: [],
      imgList: []
    }
  },

  mounted() {},

  computed: {
    showUpload() {
      return this.fileList.length >= this.limit || this.uploadShow
    },
    allImgList: {
      get() {
        return this.imageValue
      },
      set(newVal) {
        this.$emit("update:imageValue", newVal)
      }
    }
  },
  methods: {
    // 清空文件
    uploadClear() {
      this.fileList = []
      this.imgList = []
      this.$refs.upload.clearFiles()
    },
    // 上传操作
    uploadSubmit(file) {
      let formData = new FormData()
      formData.append("file", file.file)
      axios
        .post(process.env.VUE_APP_URL + "/dynamic-form/file/upload", formData, {
          headers: {
            Authorization: getToken() ? getToken() : "",
            "Content-Type": "multipart/form-data"
          }
        })
        .then((res) => {
          if (res.data.success) {
            this.imgList.push(res.data.data)

            this.$emit("uploadImgList", this.imgList)
            this.allImgList = this.imgList.join(",")
          }
        })
    },
    uploadChange(file) {
      // this.fileList = [file];
      this.fileList.push(file)
    },
    uploadPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    uploadRemove(row) {
      this.fileList.splice(this.fileList.indexOf(row), 1)
      this.imgList.splice(this.imgList.indexOf(row.url), 1)
      this.allImgList = this.imgList.join(",")
    }
  }
}
</script>

<style lang="scss">
.hidden-Btn .el-upload--picture-card {
  display: none !important;
}
.uploadDialog .el-dialog__body {
  display: flex;
  justify-content: center;
}
</style>
